<template>
  <div class="avatar-component">
    <div class="action-login" v-if="!data.isLogin">
      <span class="action-login-btn">
        <a @click="showModalLogin" class="mx-2">
          <i class="flaticon-login icon-20 mx-1"></i>
          <span>ورود | ثبت نام</span>
        </a>
      </span>
    </div>
    <div v-else class="avatar" :class="{open:data.navbar.navActive === 'isAvatar'}">
      <router-link to="/dashboard/profile">
        <span>{{user && user.fullname || 'username'}}</span>
        <figure>
          <img
            :src="user && user.img ? appUrl.media +'/'+ user.img : '/static/img/avatar.png'"
            class="img-circle"
          >
        </figure>
      </router-link>
      <i
        class="flaticon-down arrow-avatar"
        :class="{open:data.navbar.navActive}"
        @click="methods.toggle('isAvatar')"
      ></i>
      <div class="list-menu" :class="{open:data.navbar.navActive === 'isAvatar'}">
        <ul>
          <li
            v-for="(item , i) in data.navbar.listAvatar"
            :key="i"
            :class="{divider:item.divider}"
            @click="methods.toggle('isAvatar')"
          >
            <router-link :to="item.path" exact>
              <i :class="item.icon"></i>
              {{item.text}}
            </router-link>
          </li>
          <li>
            <button @click="methods.logOut" class="d-flex justify-content-center">
              <i class="icon-22 flaticon-logout ml-2"></i>
              <p class="mb-0">{{ $t('menu.exit') }}</p>
            </button>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "avatar",
  inject: {
    methods: {
      default: {}
    },
    data: {
      default: {}
    }
  }
};
</script>
<style lang="less" scoped>
@import (reference) "../../../assets/css/variable.less";
.action-login {
  text-align: center;
  cursor: pointer;
  &-btn {
    background-color: @green;
    transition: all 0.3s ease-in;
    box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.18), 0 1px 5px 0 rgba(0, 0, 0, 0.15);
    img {
      width: 20px;
      vertical-align: middle;
    }
    span {
      font-size: 14px;
      margin-right: 5px;
    }
    &:hover {
      box-shadow: 0 5px 11px 0 rgba(0, 0, 0, 0.18),
        0 4px 15px 0 rgba(0, 0, 0, 0.15);
      a {
        color: @withe;
      }
    }
  }
  > span {
    display: inline-block;
    text-align: center;
    text-decoration: none;
    height: 40px;
    line-height: 40px;
    margin: 10px auto;
    border-radius: 4px;
    transition: all 0.4s ease-in-out;
    a {
      color: @withe;
      font-size: 16px;
      font-weight: inherit;
      display: flex;
      height: 40px;
      line-height: 40px;
    }
  }
  i {
    margin-left: 5px;
  }
}
.avatar {
  width: 195px;
  position: relative;
  cursor: pointer;
  .arrow-avatar {
    color: #000;
    line-height: 60px;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    font-size: 20px;
    display: block;
    z-index: 5;
    &:before {
      .transition(all, 0.3s, ease-in);
      display: inline-block;
    }
    // &.open{
    //   transform : scale(-1,-1)
    // }
  }
  figure {
    float: left;
    margin-left: 15px;
    margin-top: 6px;
    margin-bottom: 0;
    width: 46px;
    img {
      border-radius: 100%;
      height: 46px;
      width: 46px;
      // border: 2px solid #fff;
    }
  }

  span {
    float: left;
    display: block;
    line-height: 60px;
    font-size: 13px;
    color: #000;
    width: 124px;
    padding-left: 37px;
    text-align: center;
    .elips;
  }
}

.avatar.open {
  .arrow-avatar {
    &:before {
      transform: scale(1, -1);
      .transition(all, 0.3s, ease-in);
    }
  }
}
.list-menu {
  position: absolute;
  right: 0;
  left: 0;
  background: #fff;
  border: 1px solid #fff;
  top: 60px;
  z-index: 9999;
  box-shadow: 0 0 5px 0 rgba(50, 50, 50, 0.2);
  visibility: hidden;
  opacity: 0.4;
  transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in;
  ul {
    display: block;
    margin-bottom: 0;
    li {
      width: 100%;
      background: #fff;
      text-align: center;
      position: relative;
      display: block;
      -webkit-transform-origin: 50% 0;
      transform-origin: 50% 0;
      -webkit-transform: scaleY(0);
      transform: scaleY(0);
      opacity: 0;
      transition: opacity 0.4s, transform 0.6s, max-height 0.6s;
      i {
        float: right;
        font-size: 12px;
        color: #000;
        cursor: pointer;
        height: 40px;
        line-height: 40px;
        transition: color 0.4s;
      }
      &:before {
        content: "";
        position: absolute;
        bottom: 0;
        height: 2px;
        left: 100%;
        right: 100%;
        display: block;
        background: @green;
        visibility: hidden;
        opacity: 0.3;
        transition: all 0.3s ease-in-out;
        transition: all 0.3s ease-in;
      }
      button {
        border: none;
        background-color: #fff;
      }
      button,
      a {
        padding-right: 7px;
        display: inline-block;
        width: 100%;
        font-size: 13px;
        color: #000;
        cursor: pointer;
        height: 40px;
        line-height: 40px;
        transition: color 0.4s;
      }
      &:hover {
        a,
        i {
          color: @green;
        }
        &:before {
          left: 0;
          opacity: 1;
          right: 0;
          visibility: visible;
        }
      }
      &:last-child {
        border-bottom: none;
      }
    }
    .divider {
      border-bottom: 1px solid #c9c9c9;
    }
  }
}
.open.list-menu {
  visibility: visible;
  opacity: 1;
  ul {
    visibility: visible;
    opacity: 9;
    li {
      opacity: 9;
      -webkit-transform: none;
      transform: none;
    }
  }
}

@media screen and (max-width: 992px) {
  .avatar {
    width: auto;
  }

  .list-menu {
    width: 170px;
    left: 0 !important;
    right: auto !important;
  }

  .avatar a {
    figure {
      float: left;
      margin-left: 25px;
    }
    > span {
      display: none;
    }
  }
}

@media screen and (max-width: 480px) {
  .navbarnav .action-login > span a {
    span {
      display: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ui/avatar/index.vue